import { z } from "zod";
/**
 * A workflow item whose run failed: what failed, where, in words a reviewer can read first, and how it can run
 * again for the person viewing it. `taskRunId` and `itemId` are the item retry route's body.
 */
export const workflowItemFailureSchema = z.object({
    workflowId: z.string().min(1), taskRunId: z.string().min(1), itemId: z.string().min(1),
    title: z.string().nullable(),
    errorCode: z.string().min(1).max(120), errorDetail: z.string().max(4000),
    /** A plain-language line worked out from the code and detail; the detail is the diagnostic behind it. */
    summary: z.string().min(1).max(500),
    /** The step that failed in the latest attempt, and its title; null when the item failed before any step ran. */
    nodeId: z.string().nullable(), nodeLabel: z.string().nullable(),
    failedAt: z.number().int().nonnegative(), attempt: z.number().int().nonnegative(),
    /** Temporary failures run again by themselves, at most three times. */
    automaticRetry: z.object({ count: z.number().int().min(0), nextAt: z.number().int().nullable() }).strict(),
    /**
     * `available`: this viewer can retry it; `automatic`: a retry is scheduled at `automaticRetry.nextAt`;
     * `activate`: activating the workflow again runs it, because it ran under an earlier version or a source
     * changed since activation (a retry would fail the same way); `correct`: a reviewer's correction is not in a
     * shape the workflow can use, so correcting the record again runs it (a retry would fail the same way);
     * `not_permitted`: only the workflow's owner, with channel management, can retry it, or it has changed since
     * it ran.
     */
    retry: z.enum(["available", "automatic", "activate", "correct", "not_permitted"]),
}).strict();
